import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["container", "template", "linkForm"]
  static values = {
    maxLinks: Number,
    minLinks: Number
  }

  connect() {
    this.linkCount = this.linkFormTargets.length
    this.maxLinksValue = this.maxLinksValue || 10
    this.minLinksValue = this.minLinksValue || 0
    this.updateButtonStates()

    // Renumber links on initial load to fix any duplicate names
    this.renumberLinks()
  }

  addLink() {
    if (this.linkCount >= this.maxLinksValue) {
      alert(`Maximum ${this.maxLinksValue} external links allowed`)
      return
    }

    const newLinkHtml = this.templateTarget.innerHTML
      .replace(/organization\[external_links\]\[0\]/g, `organization[external_links][${this.linkCount}]`)

    this.containerTarget.insertAdjacentHTML('beforeend', newLinkHtml)
    this.linkCount++
    this.updateButtonStates()

    // Renumber all links to ensure proper indexing
    this.renumberLinks()
  }

  removeLink(event) {
    const linkForm = event.target.closest('[data-external-links-target="linkForm"]')
    if (!linkForm) return

    if (this.linkCount <= this.minLinksValue) {
      alert(`At least ${this.minLinksValue} external link is required`)
      return
    }

    linkForm.remove()
    this.linkCount--
    this.updateButtonStates()
    this.renumberLinks()
  }

  renumberLinks() {
    this.linkFormTargets.forEach((form, index) => {
      // Update form indices
      const inputs = form.querySelectorAll('input')
      inputs.forEach(input => {
        const name = input.getAttribute('name')
        if (name && name.includes('external_links')) {
          const newName = name.replace(/organization\[external_links\]\[\d+\]/, `organization[external_links][${index}]`)
          input.setAttribute('name', newName)
        }
      })

      // Update labels
      const labels = form.querySelectorAll('label')
      labels.forEach(label => {
        const forAttr = label.getAttribute('for')
        if (forAttr && forAttr.includes('external_links')) {
          const newFor = forAttr.replace(/organization\[external_links\]\[\d+\]/, `organization[external_links][${index}]`)
          label.setAttribute('for', newFor)
        }
      })

      // Update input IDs
      inputs.forEach(input => {
        const id = input.getAttribute('id')
        if (id && id.includes('external_links')) {
          const newId = id.replace(/organization_external_links_\d+_/, `organization_external_links_${index}_`)
          input.setAttribute('id', newId)
        }
      })
    })
  }

  updateButtonStates() {
    const addButton = this.element.querySelector('[data-action="click->external-links#addLink"]')
    const removeButtons = this.element.querySelectorAll('[data-action="click->external-links#removeLink"]')

    if (addButton) {
      addButton.disabled = this.linkCount >= this.maxLinksValue
    }

    removeButtons.forEach(button => {
      button.disabled = this.linkCount <= this.minLinksValue
    })
  }

  validateForm(event) {
    const form = event.target.closest('form')
    if (!form) return

    let isValid = true
    const errors = []

    this.linkFormTargets.forEach((linkForm, index) => {
      const urlInput = linkForm.querySelector('input[name*="[url]"]')
      const titleInput = linkForm.querySelector('input[name*="[alternative_title]"]')

      if (urlInput && urlInput.value.trim() && !this.isValidUrl(urlInput.value)) {
        errors.push(`Link ${index + 1}: Invalid URL format`)
        isValid = false
      }

      if (urlInput && urlInput.value.trim() && !titleInput.value.trim()) {
        errors.push(`Link ${index + 1}: Alternative title is required when URL is provided`)
        isValid = false
      }
    })

    if (!isValid) {
      event.preventDefault()
      alert('Please fix the following errors:\n' + errors.join('\n'))
    }
  }

  isValidUrl(string) {
    try {
      const url = new URL(string)
      return url.protocol === 'http:' || url.protocol === 'https:'
    } catch (_) {
      return false
    }
  }

}
